package org.lennycodes.hldi.pages.admin
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.BlogPost


@Composable
fun UpdateBlogDialog(
    blog: BlogPost,
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var title by remember { mutableStateOf(blog.title) }
    var content by remember { mutableStateOf(blog.content) }
    var author by remember { mutableStateOf(blog.author) }
    var category by remember { mutableStateOf(blog.category) }
    var date by remember { mutableStateOf(blog.date) }
    var imageUrl by remember { mutableStateOf(blog.imageUrl) }

    var loading by remember { mutableStateOf(false) }

    var error by remember { mutableStateOf("") }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!loading) {
                        onDismiss()
                    }
                }

            }
    ) {

        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {

            H3 {
                Text("Update Blog Post")
            }


            BlogField(
                "Title",
                title,
                { title = it }
            )

            BlogField(
                "Content",
                content,
                { content = it },
                true
            )


            // Category

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Category")
                }

                Select(
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            onChange {
                                category = it.value.toString()
                            }

                            if (loading) {
                                disabled()
                            }

                        }
                ) {

                    Option(
                        value = "Education",
                        attrs = {
                            if (category == "Education") selected()
                        }
                    ) {
                        Text("Education")
                    }

                    Option(
                        value = "Legal Aid",
                        attrs = {
                            if (category == "Legal Aid") selected()
                        }
                    ) {
                        Text("Legal Aid")
                    }

                    Option(
                        value = "Health",
                        attrs = {
                            if (category == "Health") selected()
                        }
                    ) {
                        Text("Health")
                    }

                    Option(
                        value = "Community Development",
                        attrs = {
                            if (category == "Community Development") selected()
                        }
                    ) {
                        Text("Community Development")
                    }

                }

            }


            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Date")
                }

                Input(
                    type = InputType.Date,
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder("2026-08-20")

                            value(date)

                            onInput {
                                date = it.value
                            }

                            if (loading) {
                                disabled()
                            }

                        }
                )

            }


            BlogField(
                "Image URL",
                imageUrl,
                { imageUrl = it }
            )


            if (error.isNotEmpty()) {

                P(
                    attrs = Modifier
                        .color(Color.rgb(220, 53, 69))
                        .toAttrs()
                ) {
                    Text(error)
                }

            }


            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {

                Button(
                    modifier = Modifier
                        .padding(11.px, 22.px)
                        .then(CancelButtonStyle.toModifier()),
                    enabled = !loading,
                    onClick = {
                        onDismiss()
                    }
                ) {
                    Text("Cancel")
                }


                Button(
                    enabled = !loading,
                    modifier = Modifier
                        .padding(11.px, 22.px)
                        .then(SaveButtonStyle.toModifier()),
                    onClick = {

                        scope.launch {

                            try {

                                error = ""

                                if (title.isBlank()) {
                                    error = "Title is required"
                                    return@launch
                                }

                                loading = true


                                val updatedBlog = BlogPost(

                                    id = blog.id,

                                    title = title,
                                    content = content,

                                    author = author,

                                    date = date,

                                    category = category,

                                    imageUrl = imageUrl

                                )


                                setDoc(

                                    doc(
                                        collection(
                                            FirebaseService.db,
                                            "blogs"
                                        ),
                                        blog.id
                                    ),

                                    updatedBlog.toFirebaseData()

                                ).await()


                                onSuccess()

                                onDismiss()


                            } catch (e: Throwable) {

                                error = e.message ?: "Update failed"

                            } finally {

                                loading = false

                            }

                        }

                    }
                ) {

                    Text(
                        if (loading) "Updating..." else "Save"
                    )

                }

            }

        }

    }

}